import { toolKeys } from '@lbmx/types';
export default {
  '/PIMModule': toolKeys.PIM,
  '/MarketplacePartnersModule': toolKeys.MPP,
  '/AdministrationModule': toolKeys.ADMINISTRATION,
  '/MarketplaceModule': toolKeys.MP,
  '/userProfile': toolKeys.AUTHENTICATED,
};
